import { Col, Row } from "react-bootstrap"
import { useAppDispatch, useAppSelector } from "../../app/store";
import { useEffect, useState } from "react";
import { getJobTypeById, updateJobType } from "../../features/jobSlice";
import { useNavigate, useParams } from "react-router-dom";
import { PuffLoader } from "react-spinners";
import { toast } from "react-toastify";

const EditJobType = () => {
  
    const dispatch = useAppDispatch();

    const { id }=useParams();
     const {singleJobType, isLoading} = useAppSelector((state) => state.job);
      const [jobTypeName, setJobTypeName] = useState(singleJobType?.name || "");

      const Navigate = useNavigate();


    useEffect(() => {
        dispatch(getJobTypeById(id))
            .unwrap()
            .then((data) => {
                setJobTypeName(data.name);
            })
            .catch((error) => {
                toast.error("Failed to fetch job type: " + error.message);
            });
    }, [dispatch]);


    const handleUpdateJobType = (e:any) => {
        e.preventDefault();
        const data = {
            id: id,
            name: jobTypeName,
        };  
        dispatch(updateJobType(data))
            .unwrap()
            .then(() => {
                setJobTypeName("");
                Navigate("/job-settings/job-type");
                toast.success("Job type updated successfully!");
            })
            .catch((error) => {
                toast.error("Failed to update job type: " + error.message);
            });
    }

   
if(isLoading || !singleJobType) return <PuffLoader
        color="#073367"
        loading={isLoading}
        size={150}
        aria-label="Loading Spinner"
        data-testid="loader" />;
    
  return (
     <div className="pb-5">
          <Row>
            <Col md={9} sm={12} className="p-3">
              <div className="d-flex flex-row justify-content-between pt-3">
                <div>
                  Update Job Type
                </div>
      </div>
              <hr />

               <Row>
                <Col md={4} sm={12} className="p-3">
                  <form>
                    <div className="mb-3">
                      <label htmlFor="jobTypeName" className="form-label">Job Type</label>
                      <input type="text" className="form-control form-control-lg rounded-0" value={jobTypeName} id="jobTypeName" onChange={(e)=>setJobTypeName(e.target.value)} placeholder="Enter job type name" />
                    </div>
                    <button type="submit" className="btn btn-secondary rounded-0 text-white" onClick={handleUpdateJobType}>Update Job Type</button>
                  </form>
                </Col>
              </Row>
              </Col>
               <Col md={3} sm={12} style={{ backgroundColor: "#C2CFE0" }}>
                        <div className="p-3">
                          <div className="mb-2">
                            <h5>Configure your Job Type</h5>
                          </div>
              
                          <p>
                            Do you wish to send a warm and personalized acknowledgement email
                            to every candidate who applies to your company? Do you wish to
                            send a policy guide to help any employee who requests a transfer?
                            Email notifications help you customize (almost) every email that
                            is sent from Freshteam to candidates, employees, managers etc.
                          </p>
                        </div>
                      </Col>
              </Row>
             
              </div>
  )
}

export default EditJobType